//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

import React from 'react';
import { connect } from 'react-redux';
import Redux, { bindActionCreators } from 'redux';
import styled from 'styled-components';

import RequiredPermissionsButton from '@components/atoms/required-permissions-button/RequiredPermissionsButton';
import { SmallTooltip } from '@components/molecules/tooltip/Tooltip';
import { ICuralateStore } from '@models/AppState';
import InlineLoadingSpinner from '@share/components/content/loading-spinner/InlineLoadingSpinner';
import { assetFeedsModalActions } from '@streams/actions/assetFeedsModalActions';
import { ASSET_FEEDS_MANAGE_PERMISSION } from '@tagging/constants/taggingConstants';

function mapStateToProps(state: ICuralateStore) {
  return {
    isEditingSources: state.streams.assetFeedsModal.isEditingSources,
    isUpdatingSources: state.streams.assetFeedsModal.isUpdatingSources,
    sourceSettings: state.streams.assetFeedsModal.sourceSettings,
  };
}

function mapDispatchToProps(dispatch: Redux.Dispatch) {
  return {
    actions: {
      assetFeedsModal: bindActionCreators(assetFeedsModalActions, dispatch),
    },
  };
}

interface Props
  extends ReturnType<typeof mapDispatchToProps>,
    ReturnType<typeof mapStateToProps>,
    React.HTMLAttributes<HTMLDivElement> {
  buttonText: string;
}

export const StreamsDrawerAssetFeedsUpdateSourcesButton = (props: Props) => {
  const {
    actions,
    buttonText,
    className,
    isEditingSources,
    isUpdatingSources,
    sourceSettings,
  } = props;

  const allSourcesDisabled = !Object.values(sourceSettings).includes(true);

  return (
    <SmallTooltip
      content={<div>You must select at least one source.</div>}
      isDisabled={!allSourcesDisabled}
      target={
        <UpdateButton
          className={className}
          isDisabled={
            !isEditingSources || isUpdatingSources || allSourcesDisabled
          }
          onClick={actions.assetFeedsModal.createOrUpdateAssetFeedsStream}
          permissionName={ASSET_FEEDS_MANAGE_PERMISSION}
        >
          {buttonText}
          <InlineLoadingSpinner
            className='cu-ml-2'
            shouldShowSpinner={isUpdatingSources}
          />
        </UpdateButton>
      }
    />
  );
};

// Hard code width to prevent jumping when loading spinner appears
const UpdateButton = styled(RequiredPermissionsButton)`
  width: 125px;
`;

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(StreamsDrawerAssetFeedsUpdateSourcesButton);
